import {
  Component,
  OnInit,
  ViewChild,
  Directive,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from "@angular/core";
import {
  SiniestroTracking,
  MensajeCampoValor,
  CampoValor,
  ArchivoDocumentoAsitenciaMedica,
  DatosSiniestroAsistenciaMedica,
  DocumentosActualizar, MensajeSiniestro, MensajeDocumentos
} from "../siniestros_entity";
import { SiniestrosService } from "../siniestros.service";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
import { ConstantService } from "../../../components/common/utils/constant.service";
import { SessionStorageService } from "ngx-webstorage";
const swal = require("sweetalert2");
declare var jQuery: any;
@Component({
  selector: "trackingVehiculo",
  templateUrl: "tracking-siniestros-vehiculos.template.html",
  styleUrls: ["tracking-siniestros-vehiculos.styles.css"],
})
export class TrackingVehiculoComponent implements OnInit, OnChanges {
  reporteRecibido: boolean;
  documentacion: boolean;
  inspeccion: boolean;
  autorizacionReparacion: boolean;
  reparacion: boolean;
  cierre: boolean;

  link_reporteRecibido: boolean;
  link_documentacion: boolean;
  link_inspeccion: boolean;
  link_autorizacionReparacion: boolean;
  link_reparacion: boolean;
  link_cierre: boolean;

  @Input()
  trackingVehiculo: SiniestroTracking;
  @Input()
  codigoUnico: number;

  resultadoTracking: SiniestroTracking;
  resultadoTrackingDeducible: SiniestroTracking;
  link_documentacionDeducible: boolean;
  documentacionDeducible: boolean;
  cierreDeducible: boolean;
  link_cierreDeducible: boolean;
  resultadoRcDeducible: MensajeCampoValor[] = new Array<MensajeCampoValor>();

  deducibles: CampoValor[] = new Array<CampoValor>();
  rcs: MensajeCampoValor[] = new Array<MensajeCampoValor>();

  banderaDeducible: boolean = false;
  banderaRcs: boolean = false;

  @ViewChild("deducible")
  modalDed: ModalComponent;
  @ViewChild("rcsModal")
  modalRcs: ModalComponent;
  current: number;
  docsCliente: ArchivoDocumentoAsitenciaMedica[] = new Array<
    ArchivoDocumentoAsitenciaMedica
  >();
  devolverMensaje: any;
  showLoader: string = "";
  formData: FormData = new FormData();
  files: File[] = [];
  url: string = "utils";
  docsActualizar: DocumentosActualizar = new DocumentosActualizar();

  constructor(
    private siniestrosService: SiniestrosService,
    private handleError: HandleError,
    public sesionStorageService: SessionStorageService
  ) {
    this.reporteRecibido = false;
    this.documentacion = false;
    this.inspeccion = true;
    this.autorizacionReparacion = false;
    this.reparacion = false;
    this.cierre = false;

    this.link_reporteRecibido = true;
    this.link_documentacion = true;
    this.link_inspeccion = true;
    this.link_autorizacionReparacion = false;
    this.link_reparacion = false;
    this.link_cierre = false;

    this.resultadoTracking = new SiniestroTracking();
    this.resultadoTracking.Documentacion = new MensajeDocumentos();
    this.resultadoTracking.Documentacion.documentosFaltantes = new Array<ArchivoDocumentoAsitenciaMedica>();
    this.resultadoTracking.Documentacion.documentosEntregados = new Array<ArchivoDocumentoAsitenciaMedica>();
    this.link_documentacionDeducible = false;
    this.documentacionDeducible = false;
    this.link_cierreDeducible = false;
    this.cierreDeducible = false;
    let constantService = new ConstantService();
    this.url = constantService.API_ENDPOINT + this.url;
    this.docsActualizar = new DocumentosActualizar();
    this.docsActualizar.DocumentosReclamo = new Array<
      ArchivoDocumentoAsitenciaMedica
    >();

    this.devolverMensaje = (parametro: number, documento: any): void => {
      if (parametro == 200) {
        let rcl = JSON.parse(documento);
        swal({
          title: "Actualizar Documentación",
          text: "Su información ha sido enviada satisfactoriamente",
          type: "success",
        }).then(() => {
          window.location.reload();
        });

        this.docsCliente = new Array<ArchivoDocumentoAsitenciaMedica>();
        this.showLoader = "";
        this.formData = new FormData();
      } else {
        swal({
          title: "Actualizar Documentación",
          text:
            "Existio un error, por favor intentelo más tarde, lamentamos el inconveniente.",
          type: "error",
        });
        this.showLoader = "";
        this.formData = new FormData();
      }
    };
  }

  ngOnInit() {
    this.resultadoTracking = this.trackingVehiculo;
    this.siniestrosService.DetalleDeducible(this.codigoUnico).subscribe(
      (resultDeducible) => {
        if (resultDeducible != null && resultDeducible != undefined) {
          this.resultadoTrackingDeducible = resultDeducible;
          if (
            (this.resultadoTrackingDeducible.Documentacion != null &&
              this.resultadoTrackingDeducible.Documentacion != undefined) ||
            (this.resultadoTrackingDeducible.Liquidacion != null &&
              this.resultadoTrackingDeducible.Liquidacion != undefined)
          ) {
            this.banderaDeducible = true;
          } else {
            this.banderaDeducible = false;
          }

          if (
            this.resultadoTrackingDeducible.Documentacion != null &&
            this.resultadoTrackingDeducible.Documentacion != undefined
          ) {
            this.documentacionDeducible = true;
            this.link_documentacionDeducible = true;
          }
          if (
            this.resultadoTrackingDeducible.Liquidacion != null &&
            this.resultadoTrackingDeducible.Liquidacion != undefined
          ) {
            //this.cierreDeducible = true;
            this.link_cierreDeducible = true;
          }
        }
      },
      (error) => {
        this.handleError.redirectUrl(error);
      }
    );

    this.siniestrosService.DetalleRcs(this.codigoUnico).subscribe(
      (resultRcsDeducible) => {
        if (resultRcsDeducible != null && resultRcsDeducible != undefined && resultRcsDeducible.length>0) {
          this.resultadoRcDeducible = resultRcsDeducible;
          this.resultadoRcDeducible.forEach((a) => {
            if (a.error == "Deducible") {
              this.deducibles = a.listaValores;
            }
            if (a.error != "Deducible") {
              this.rcs.push(a);
              this.banderaRcs = true;
            }
          });
        }
      },
      (error) => {
        this.handleError.redirectUrl(error);
      }
    );

    if (this.resultadoTracking.DetalleSiniestro != null) {
      this.reporteRecibido = true;
      this.documentacion = false;
      this.inspeccion = false;
      this.autorizacionReparacion = false;
      this.reparacion = false;
      this.cierre = false;
      this.link_reporteRecibido = true;
    }
    if (this.resultadoTracking.Documentacion != null) {
      this.reporteRecibido = false;
      this.documentacion = true;
      this.inspeccion = false;
      this.autorizacionReparacion = false;
      this.reparacion = false;
      this.cierre = false;
      this.link_documentacion = true;
    }
    if (this.resultadoTracking.Inspeccion != null) {
      this.reporteRecibido = false;
      this.documentacion = false;
      this.inspeccion = true;
      this.autorizacionReparacion = false;
      this.reparacion = false;
      this.cierre = false;
      this.link_inspeccion = true;
    }
    if (this.resultadoTracking.Autorizacion != null) {
      this.reporteRecibido = false;
      this.documentacion = false;
      this.inspeccion = false;
      this.autorizacionReparacion = true;
      this.reparacion = false;
      this.cierre = false;
      this.link_autorizacionReparacion = true;
    }
    if (this.resultadoTracking.Reparacion != null) {
      this.reporteRecibido = false;
      this.documentacion = false;
      this.inspeccion = false;
      this.autorizacionReparacion = false;
      this.reparacion = true;
      this.cierre = false;
      this.link_reparacion = true;
    }
    if (this.resultadoTracking.Liquidacion != null) {
      this.reporteRecibido = false;
      this.documentacion = false;
      this.inspeccion = false;
      this.autorizacionReparacion = false;
      this.reparacion = false;
      this.cierre = true;
      this.link_cierre = true;
    }
  }
  ngOnChanges() {
    this.resultadoTracking = this.trackingVehiculo;
    if (this.resultadoTracking.DetalleSiniestro != null) {
      this.reporteRecibido = true;
      this.documentacion = false;
      this.inspeccion = false;
      this.autorizacionReparacion = false;
      this.reparacion = false;
      this.cierre = false;
      this.link_reporteRecibido = true;
    } else {
      this.link_reporteRecibido = false;
    }
    if (this.resultadoTracking.Documentacion != null) {
      this.reporteRecibido = false;
      this.documentacion = true;
      this.inspeccion = false;
      this.autorizacionReparacion = false;
      this.reparacion = false;
      this.cierre = false;
      this.link_documentacion = true;
    } else {
      this.link_documentacion = false;
    }
    if (this.resultadoTracking.Inspeccion != null) {
      this.reporteRecibido = false;
      this.documentacion = false;
      this.inspeccion = true;
      this.autorizacionReparacion = false;
      this.reparacion = false;
      this.cierre = false;
      this.link_inspeccion = true;
    } else {
      this.link_inspeccion = false;
    }
    if (this.resultadoTracking.Autorizacion != null) {
      this.reporteRecibido = false;
      this.documentacion = false;
      this.inspeccion = false;
      this.autorizacionReparacion = true;
      this.reparacion = false;
      this.cierre = false;
      this.link_autorizacionReparacion = true;
    } else {
      this.link_autorizacionReparacion = false;
    }
    if (this.resultadoTracking.Reparacion != null) {
      this.reporteRecibido = false;
      this.documentacion = false;
      this.inspeccion = false;
      this.autorizacionReparacion = false;
      this.reparacion = true;
      this.cierre = false;
      this.link_reparacion = true;
    } else {
      this.link_reparacion = false;
    }
    if (this.resultadoTracking.Liquidacion != null) {
      this.reporteRecibido = false;
      this.documentacion = false;
      this.inspeccion = false;
      this.autorizacionReparacion = false;
      this.reparacion = false;
      this.cierre = true;
      this.link_cierre = true;
    } else {
      this.link_cierre = false;
    }
  }

  accion(paso: number) {
    switch (paso) {
      case 1:
        this.reporteRecibido = true;
        this.documentacion = false;
        this.inspeccion = false;
        this.autorizacionReparacion = false;
        this.reparacion = false;
        this.cierre = false;
        break;
      case 2:
        this.reporteRecibido = false;
        this.documentacion = true;
        this.inspeccion = false;
        this.autorizacionReparacion = false;
        this.reparacion = false;
        this.cierre = false;
        break;
      case 3:
        this.reporteRecibido = false;
        this.documentacion = false;
        this.inspeccion = true;
        this.autorizacionReparacion = false;
        this.reparacion = false;
        this.cierre = false;
        break;
      case 4:
        this.reporteRecibido = false;
        this.documentacion = false;
        this.inspeccion = false;
        this.autorizacionReparacion = true;
        this.reparacion = false;
        this.cierre = false;
        break;
      case 5:
        this.reporteRecibido = false;
        this.documentacion = false;
        this.inspeccion = false;
        this.autorizacionReparacion = false;
        this.reparacion = true;
        this.cierre = false;
        break;
      case 6:
        this.reporteRecibido = false;
        this.documentacion = false;
        this.inspeccion = false;
        this.autorizacionReparacion = false;
        this.reparacion = false;
        this.cierre = true;
        break;
    }
  }
  openDeducible() {
    this.modalDed.open();
  }
  openRcs() {
    this.modalRcs.open();
  }

  CrearDocumento(document: ArchivoDocumentoAsitenciaMedica) {
    let a = this.docsCliente.length;
    let codigo = 1;

    codigo =
      Math.max.apply(
        Math,
        this.docsCliente.map(function (o) {
          return o.IdDocumento;
        })
      ) + 1;
    if (!isFinite(codigo)) {
      codigo = 1;
    }

    let doc = new ArchivoDocumentoAsitenciaMedica();
    doc.TipoDocumento = document.TipoDocumento;
    doc.IdDocumento = codigo;
    doc.IdSiniestro=document.IdSiniestro;
    this.docsCliente.push(doc);
  }

  fileChange(archivo: any, doc: ArchivoDocumentoAsitenciaMedica) {
    let archivoEncontrado = undefined;
    if (this.files != undefined) {
      archivoEncontrado = this.files.filter(
        (a) => a.name == archivo.target.files[0].name
      );
    }
    if (
      archivoEncontrado != null &&
      archivoEncontrado != undefined &&
      archivoEncontrado.length > 0
    ) {
      swal({
        title: "Archivo ",
        text: "El nombre de archivo ya existe, por favor modifique su nombre",
        type: "error",
      });
    } else {
      doc.Descripcion = archivo.target.files[0].name;
      doc.TipoMIME = archivo.target.files[0].type;
      this.files.push(archivo.target.files[0]);
    }
  }
  eliminarArchivo(doc: ArchivoDocumentoAsitenciaMedica) {
    this.docsCliente = JSON.parse(
      JSON.stringify(
        this.docsCliente.filter((a) => a.IdDocumento != doc.IdDocumento)
      )
    );
    this.files = this.files.filter((a) => a.name != doc.Descripcion);
  }
  EnviarDocumentos() {
    this.showLoader = "sk-loading";
    this.docsActualizar.MedioReporte = 1909;
    this.docsActualizar.DocumentosReclamo = JSON.parse(
      JSON.stringify(this.docsCliente)
    );
    this.files.forEach((a) => {
      this.formData.append(a.name, a, a.name);
    });

    this.formData.append("Siniestro", JSON.stringify(this.docsActualizar));

    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        this.devolverMensaje(xhr.status, xhr.response);
      }
    }.bind(this);
    xhr.open("post", this.url + "/GetActualizarDocsSiniestro", true);
    xhr.setRequestHeader("enctype", "multipart/form-data");
    // IE workaround for Cache issues
    xhr.setRequestHeader("Cache-Control", "no-cache");
    xhr.setRequestHeader("Cache-Control", "no-store");
    xhr.setRequestHeader("Pragma", "no-cache");
    xhr.setRequestHeader(
      "Authorization",
      "Token " + this.sesionStorageService.retrieve("Token")
    );
    xhr.setRequestHeader("Reclamos", JSON.stringify(this.docsActualizar));

    xhr.send(this.formData);
  }
}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/siniestros/tracking/tracking-siniestros-vehiculos.component.ts